var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"site"},[_c('site-loader',{ref:"loader"}),_c('site-header'),_c('div',{staticClass:"site__content"},[_c('router-view')],1),_c('site-footer'),(_vm.infoMessages.length)?_c('alert-message'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }